const configuredApiBase = String(import.meta.env.VITE_API_BASE_URL || '').trim().replace(/\/$/, '')

if (import.meta.env.PROD && configuredApiBase && !configuredApiBase.startsWith('https://')) {
  throw new Error('Production VITE_API_BASE_URL must use HTTPS')
}

export const runtimeConfig = Object.freeze({
  apiBaseUrl: configuredApiBase,
  apiMode: configuredApiBase ? 'configured-https-origin' : 'same-origin',
  environment: String(import.meta.env.VITE_APP_ENV || import.meta.env.MODE || 'production'),
})

export function apiUrl(pathname) {
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`
  return `${runtimeConfig.apiBaseUrl}${normalizedPath}`
}
